import axios from "axios";

const API = axios.create({
  baseURL: "/web/tele",
});

const clearSession = () => {
  localStorage.removeItem("teleAccessToken");
  localStorage.removeItem("teleRefreshToken");
  localStorage.removeItem("teleSessionUuid");
  localStorage.removeItem("teleUser");
  localStorage.removeItem("telePermissions");
};

let refreshPromise = null;

// One refresh at a time; concurrent 401s wait for the same request.
const refreshAccessToken = () => {
  if (!refreshPromise) {
    const refreshToken = localStorage.getItem("teleRefreshToken");
    refreshPromise = axios
      .post("/web/tele/auth/refresh", { refreshToken })
      .then((res) => {
        const data = res.data.data || res.data;
        const accessToken = data.token || data.accessToken;
        localStorage.setItem("teleAccessToken", accessToken);
        localStorage.setItem("teleRefreshToken", data.refreshToken);
        return accessToken;
      })
      .finally(() => {
        refreshPromise = null;
      });
  }
  return refreshPromise;
};

// Attach the access token to every request
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("teleAccessToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// On 401, attempt one token refresh before hard-logout
API.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const isAuthCall = originalRequest && /\/auth\/(login|refresh)$/.test(originalRequest.url || "");
    if (
      error.response &&
      error.response.status === 401 &&
      !isAuthCall &&
      !originalRequest._retry &&
      localStorage.getItem("teleRefreshToken")
    ) {
      originalRequest._retry = true;
      try {
        const newToken = await refreshAccessToken();
        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return API(originalRequest);
      } catch (refreshError) {
        clearSession();
        window.location.href = "/tele/login";
        return Promise.reject(refreshError);
      }
    }
    if (error.response && error.response.status === 401 && !isAuthCall) {
      clearSession();
      window.location.href = "/tele/login";
    }
    return Promise.reject(error);
  }
);

export default API;
export { clearSession, refreshAccessToken };
